import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ProjectAttachmentModel from '../../../models/ProjectAttachmentModel';
import DataService from "../../../services/data.service";
import { ProjectProps } from '../../../types/IdProps';
import AddProjectAttachmentPopup from '../Popups/Project_popup_AddAttachment';
import ReviseAttachmentPopup from '../../Common/Popups/Attachment_popup_ReviseAttachment';

const Project_tab_Attachments: React.FC<ProjectProps> = ({ projectId, projectTypeId, refreshDataCounter }) => {
    const [data, setData] = useState<any[]>();
    const [selectedAttachmentId, setSelectedAttachmentId] = useState<number>()
    const [showAddPopup, setShowAddPopup] = useState<boolean>(false)
    const [showRevisePopup, setShowRevisePopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForAttachmentType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [projectId, refreshDataCounter]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ProjectAttachments/ByProject/' + projectId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function downloadAttachment(rowData: ProjectAttachmentModel) {
        if (rowData.attachmentLatestVersion.fileUrl) {
            const link = document.createElement('a');
            link.href = rowData.attachmentLatestVersion.fileUrl;
            link.download = rowData.attachmentLatestVersion.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    function viewAttachment(rowData: ProjectAttachmentModel) {
        if (rowData.attachmentLatestVersion.fileUrl) {
            const link = document.createElement('a');
            link.href = rowData.attachmentLatestVersion.fileUrl;

            if (rowData.attachmentLatestVersion.fileName.endsWith('.ai'))
                link.download = rowData.attachmentLatestVersion.fileName.replace('.ai', '.pdf');

            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    function reviseAttachment(rowData: ProjectAttachmentModel) {
        setSelectedAttachmentId(rowData.attachment.id)
        setShowRevisePopup(true)
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ProjectAttachments/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(row): boolean {
        if (row.attachment.attachmentType.canDelete && isAuthorizedForAttachmentType(ApplicationFunctions.DeleteAttachment, row.attachment.attachmentTypeId))
            return true

        return false;
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'attachmentId', visible: false },
        { title: 'Name', dataProp: 'attachment', dataType: 'thumbnail', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Type', dataProp: 'attachment.attachmentType.name', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Version', dataProp: 'attachment.latestVersion', dataType: 'number', width: 100, filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Created on', dataProp: 'attachment.createdOn', dataType: 'datetime' },
        { title: 'Created by', dataProp: 'attachment.createdByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
        {
            width: 70,
            sort: false,
            rowButtons: [
                { text: "Download", icon: 'fa-cloud-download', color: 'rgb(137, 196, 244)', onClick: downloadAttachment },
                { text: "View", icon: 'fa-eye', color: 'rgb(137, 196, 244)', onClick: viewAttachment },
                { text: "Revise", icon: 'fa-edit', color: 'rgb(137, 196, 244)', onClick: reviseAttachment }
            ]
        },

    ];

    if (isAuthorizedForAttachmentType(ApplicationFunctions.CreateAttachment) || isAuthorizedForAttachmentType(ApplicationFunctions.DeleteAttachment)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowAddPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }]
            }
        );
    }

    return (
        <>
            {data && (
                <DataTable
                    name='dtProjectAttachments'
                    colInfos={colInfos}
                    tableData={data}
                    navigateTitle='Attachment'
                    navigateUrl='/plm/Common/Attachment/'
                />
            )}
            {showAddPopup && <AddProjectAttachmentPopup projectId={projectId} projectTypeId={projectTypeId} show={showAddPopup} onHide={() => { setShowAddPopup(false); getTableData(); }} />}
            {showRevisePopup && selectedAttachmentId && <ReviseAttachmentPopup attachmentId={selectedAttachmentId} show={showRevisePopup} onHide={() => { setShowRevisePopup(false); getTableData(); }} />}
        </>
    );
}
export default Project_tab_Attachments;